export const icReferenceTypes = [
  { value: 'FIXED', label: 'مقدار ثابت', disabled: false },
  { value: 'BASELINE', label: 'خط مبنا', disabled: false },
  { value: 'CALIBRATION_VALUE', label: 'مقدار کالیبراسیون — فعلاً قابل استفاده نیست', disabled: true },
  { value: 'REFERENCE_EQUIPMENT', label: 'تجهیز مرجع — فعلاً قابل استفاده نیست', disabled: true },
  { value: 'PREVIOUS_RESULT', label: 'نتیجه قبلی — منتظر روش اجرایی مصوب', disabled: true }
];

export function icReferenceUnavailable(value: string): boolean {
  return icReferenceTypes.some(x => x.value === value && x.disabled);
}
